
export type IndexSourceType = "None" | "Documents" | "TimeSeries" | "Counters";